import { ContactFormFields } from './components/ContactForm/ContactForm.models';
import { Validators } from '@/utils/helpers/validation';
import { FormFieldType } from '@/components/FormField/formfield.models';
import { LandStatus, Salutation } from '@/utils/api';

export const getInitialFormData = (): ContactFormFields => ({
  salutation: {
    required: true,
    value: '',
    type: FormFieldType.Select,
    options: [Salutation.MR, Salutation.MS],
    hasError: false,
    autocompleteTag: 'honorific-prefix',
    validators: [Validators.notEmpty(), Validators.isPartOf([Salutation.MR, Salutation.MS])],
    tabbable: true
  },
  firstname: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'given-name',
    validators: [Validators.notEmpty()],
    tabbable: true
  },
  lastname: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'family-name',
    validators: [Validators.notEmpty()],
    tabbable: true
  },
  mail: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'email',
    validators: [Validators.isEmail()],
    tabbable: true
  },
  phone: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'tel',
    validators: [Validators.isPhone()],
    tabbable: true
  },
  street: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'street-address',
    validators: [Validators.notEmpty(), Validators.minLength(3), Validators.maxLength(50)],
    tabbable: true
  },
  number: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    validators: [Validators.notEmpty(), Validators.maxLength(10)],
    tabbable: true
  },
  zip: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'postal-code',
    validators: [Validators.isNumber()],
    tabbable: true
  },
  city: {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'address-level2',
    validators: [Validators.notEmpty(), Validators.minLength(3), Validators.maxLength(30)],
    tabbable: true
  },
  countryCode: {
    required: true,
    value: '',
    type: FormFieldType.Select,
    options: ['DE', 'AT', 'CH'],
    hasError: false,
    autocompleteTag: 'country',
    validators: [Validators.notEmpty(), Validators.isPartOf(['DE', 'AT', 'CH'])],
    tabbable: true
  },
  landAvailable: {
    required: true,
    value: '',
    type: FormFieldType.Select,
    options: [LandStatus.BOUGHT, LandStatus.EXPECTED, LandStatus.RESERVED, LandStatus.NONE],
    hasError: false,
    autocompleteTag: 'land-available',
    validators: [
      Validators.notEmpty(),
      Validators.isPartOf([LandStatus.BOUGHT, LandStatus.EXPECTED, LandStatus.RESERVED, LandStatus.NONE])
    ],
    tabbable: true
  },
  landFieldNumber: {
    required: false,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'field-number',
    validators: [Validators.notEmpty()], // TODO: check correct validator
    tabbable: true
  },
  landZip: {
    required: false,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'zip',
    validators: [Validators.notEmpty()],
    tabbable: true
  },
  landCity: {
    required: false,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'city',
    validators: [Validators.notEmpty()],
    tabbable: true
  },
  message: {
    required: false,
    value: '',
    type: FormFieldType.Textarea,
    hasError: false,
    validators: [Validators.notEmpty(), Validators.maxLength(5000)],
    maxlength: 5000,
    tabbable: true
  },
  eosum: {
    required: false,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    validators: [Validators.maxLength(0)],
    tabbable: false
  }
});
